<div class="cart-empty-wrapper">
    <!-- Cart icon -->
    <div class="icon-container">
        <svg class="cart-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="cart-circle" cx="26" cy="26" r="25" fill="none"/>
            <path class="cart-path" fill="none" stroke-linecap="round" stroke-linejoin="round"
                d="M15 18h22l-3 12H18l-3-12zm0 0l-2-6h-3m5 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm14 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"
                transform="translate(2, 2) scale(0.9)"/>
        </svg>
    </div>

    <h2>{{ 'headertop.empty_cart' | T }}</h2>
    

    <div class="actions">
        <!-- <button class="btn-primary" (click)="goToProducts()">
            {{ 'esito.cont_shopping' | T }}
        </button> -->
        <button class="btn-primary" (click)="goToHome()">
            {{ 'goto_home' | T }}
        </button>
    </div>
</div>